import { render, staticRenderFns } from "./InstagramInstantwinCampaignAnalyticsMessageSendCountsTab.vue?vue&type=template&id=51ebbdf2&scoped=true"
import script from "./InstagramInstantwinCampaignAnalyticsMessageSendCountsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramInstantwinCampaignAnalyticsMessageSendCountsTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramInstantwinCampaignAnalyticsMessageSendCountsTab.vue?vue&type=style&index=0&id=51ebbdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ebbdf2",
  null
  
)

export default component.exports